var initialWishlist = userWishlist || {};
var localWishlist = JSON.parse(localStorage.getItem('wish-list')) || {};
var resync = false;

if(Object.keys(localWishlist).length != Object.keys(localWishlist).length) {
	resync = true;
}

Object.assign(initialWishlist, localWishlist);


document.addEventListener('alpine:init', () => {
	Alpine.store('wishlist', {
		products: {},
		handles: [],
		init: function() {
			this.products = initialWishlist;
			this.handles = Object.keys(this.products);
			if(resync) {
				console.log("Resync needed");
				this.persist();
			}
		},
		toggle: function (handle, variantId) {
			if (this.hasProduct(handle)) {
				delete this.products[handle];
				this.handles.splice(this.handles.indexOf(handle), 1);
			} else {
				this.products[handle] = variantId;
				this.handles.push(handle);
			}

			this.products = Object.assign({}, this.products);
			localStorage.setItem('wish-list', JSON.stringify(this.products))
			this.persist();
		},
		hasProduct: function (handle) {
			return this.handles.indexOf(handle) > -1;
		},
		hasAnyProduct: function () {
			return this.handles.length > 0;
		},
		persist: function() {
			if (typeof customerId !== 'undefined') {

				$.post('https://app.beaufortandblake.co.uk/api/wishlist', {
					customerId: customerId,
					wishlist: this.products
				}) // .then(() => { console.log("Persisted") });
			}
		}
	});

  Alpine.data('mobileScroller', () => ({
    init() {
      this.handleScroll();
    },
    activeDot: '',
    handleScroll() {
      let closest = null;

      this.$refs.slider.querySelectorAll('div').forEach((slide) => {
        if(!closest) {
          closest = slide;
          return;
        }

        if(Math.abs(slide.getBoundingClientRect().left) < Math.abs(closest.getBoundingClientRect().left)) {
          closest = slide;
        }
      });

      this.activeDot = closest.dataset.size;
    },

    scrollToDot(size) {
      let match = this.$refs.mailEl.querySelector('[data-size="'+size+'"]');

      if(match) {
        this.$refs.slider.scrollTo({ left: this.$refs.slider.scrollLeft + match.getBoundingClientRect().left - 14, behavior: 'smooth' });
      }
    }
  }))

  /*
   * Instant search
   */
  Alpine.data('instantSearch', (markupId, searchUrl) => ({
    searchTerm: '',
    searchUrl: searchUrl,
    open: false,
    limit: 4,
    markupId: markupId,
    hasSearched: false,
    showCats: true,

    doNormalSearch() {
      if(this.searchTerm.length != '') {
        if(this.hasSearched && this.showCats) {
          // No results search, so don't redirect
        } else {
          window.location.href = this.searchUrl + "?q=" + this.searchTerm;
        }
      }
    },

    searchTermChanged() {
      if(this.searchTerm.length >= 3) {
        this.search();
      } else {
        if(this.hasSearched) {
          this.$refs.results.innerHTML = '';
          this.showCats = true;
        }
      }
    },
    search() {
      fetch(`/search/suggest?q=${this.searchTerm}&section_id=predictive-search&resources[limit]=${this.limit}&resources[limit_scope]=each&resources[type]=query,product,page`)
        .then((response) => {
          if (!response.ok) {
            alert(response.status);
            return;
          }
          return response.text();
        })
        .then((text) => {
          this.open = true;
          this.hasSearched = true;
          this.$refs.results.innerHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
          this.showCats = this.$refs.results.innerHTML.indexOf('js-no-results') > -1;
        });
    }
  }))

  /*
   * PDP carousel for mobile
   */
  Alpine.data('mobileCarousel', (slideCount, videoIndex) => ({
    scrollPercent: 0,
    dotIndex: 1,
    firedEvent: false,
    videoIndex: videoIndex ? videoIndex : -1,
    slideCount: slideCount,
    updateDots() {
      this.scrollPercent = this.$refs.slider.scrollLeft / this.$refs.slider.scrollWidth;
      this.dotIndex = Math.round(this.scrollPercent * this.slideCount) + 1;
      if(this.dotIndex === videoIndex && !this.firedEvent) {
        document.dispatchEvent(new CustomEvent('video_seen', { detail: { 'size': 'mobile' }, bubbles: true }));
        this.firedEvent = true;
      }
    },
    goToDot(index) {
      this.$refs.slider.scrollTo({ left: ((index - 1) / this.slideCount) * this.$refs.slider.scrollWidth, behavior: 'smooth' });
    }
  }));

  /*
   * Generic carousel
   */
  Alpine.data('carousel', (slideCount, auto, infinite = false) => ({
    auto: auto,
    slideCount: slideCount,
    scrollTimeout: null,
    chevronClicked: false,
    slides: [],
    infinite: infinite,
    dotIndex: 0,

    init() {

      if(this.slideCount > 1 && this.infinite) {
        let slides = this.$el.querySelectorAll('.carousel-slide');

				// Clone first and last slides
				const firstClone = slides[0].cloneNode(true);
				const lastClone = slides[slides.length - 1].cloneNode(true);

        this.$refs.carousel.style.scrollBehavior = "auto"

				this.$refs.carousel.appendChild(firstClone);
				this.$refs.carousel.insertBefore(lastClone, slides[0]);

        this.slides = this.$el.querySelectorAll('.carousel-slide');
        this.slideCount = this.slides.length;

        requestAnimationFrame(() => {
          this.$refs.carousel.scrollLeft = this.slides[1].offsetLeft;
          this.$refs.carousel.style.scrollBehavior = "smooth"
        });
      }

      if(this.auto > 0) {
        this.finishedScrolling();
      }
    },
    finishedScrolling() {
      if(this.auto > 0 && !this.chevronClicked) {
        if(this.scrollTimeout) {
          clearTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
          if((this.dotIndex + 1) >= this.slideCount) {
            this.$refs.carousel.scrollTo({ left: 0, behavior: 'smooth' });
            this.dotIndex = 0;
          } else {
            this.scroll(1);
          }
        }, this.auto * 1000);
      }

      if(this.infinite && this.slideCount > 1) {
        // If slide count > 1, then we need to check if we are on first or last, and move to the non clone
        if (this.$refs.carousel.scrollLeft >= this.slides[this.slides.length - 1].offsetLeft) {
          this.$refs.carousel.style.scrollBehavior = "auto"; // Disable smooth scrolling temporarily
          this.$refs.carousel.scrollLeft = this.slides[1].offsetLeft; // Jump to first real slide
          this.$refs.carousel.style.scrollBehavior = "smooth"; // Re-enable smooth scrolling
        }

        if (this.$refs.carousel.scrollLeft <= this.slides[0].offsetLeft) {
          this.$refs.carousel.style.scrollBehavior = "auto";
          this.$refs.carousel.scrollLeft = this.slides[this.slides.length - 2].offsetLeft; // Jump to last real slide
          this.$refs.carousel.style.scrollBehavior = "smooth";
        }
      }
    },

    updateDotindex() {
      let scrollPercent = this.$refs.carousel.scrollLeft / this.$refs.carousel.scrollWidth;
      this.dotIndex = Math.round(scrollPercent * this.slideCount);
    },
    scroll(direction) {
      if(direction == 1) {
        this.dotIndex = Math.min(this.slideCount - 1, this.dotIndex + 1)
      } else {
        this.dotIndex = Math.max(0, this.dotIndex - 1)
      }

      this.$refs.carousel.scrollTo({ left: (this.dotIndex / this.slideCount) * this.$refs.carousel.scrollWidth, behavior: 'smooth' });
    },

    manualScroll(direction) {
      clearTimeout(this.scrollTimeout);
      this.chevronClicked = true;
      this.scroll(direction);
    }
  }));

  /*
   * Carousel which scrolls into gutters (v2-product-slider)
   */
  Alpine.data('carouselV2', () => ({
    scrolled: false,
    leftActive: false,
    rightActive: true,
    dotIndex: 1,
    updateArrows() {
      this.rightActive = this.$refs.slider.scrollLeft < this.$refs.slider.scrollWidth - this.$refs.slider.clientWidth;
      this.leftActive = this.$refs.slider.scrollLeft > 0;
    },
    scrollToCard(id) {
      document.getElementById(id).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
    },
    updateDot() {
      let slideCount = this.$refs.slider.querySelectorAll('.product-carousel-product').length;
      this.scrollPercent = this.$refs.slider.scrollLeft / this.$refs.slider.scrollWidth;
      this.dotIndex = Math.round(this.scrollPercent * slideCount) + 1;
    },

  }));

  /*
  * Countdown
  */
  Alpine.data('epoch', (targetEpoch) => {
    return {
      targetEpoch: targetEpoch,
      init() {
        setInterval(() => this.tick(), 1000);
        this.tick();
      },
      tick() {
        let now = new Date(),
            cutoff = new Date(this.targetEpoch),
            diff = ((cutoff.getTime() - now.getTime()) / 1000);

        if(diff < 0) {
          this.text = '';
          return;
        }

        days = parseInt(Math.floor(diff / 86400));
        hours = parseInt(Math.floor(diff / 3600) % 24);
        mins = ('0' + parseInt(Math.floor((diff % 3600) / 60))).substr(-2);
        seconds = ('0' + parseInt(diff % 60)).substr(-2);

        this.text = days + ' days ' + hours + ' hrs ' + mins + ' mins ';
      },
      text: ''
    }
  });

  Alpine.data('productCard', () => {
    return {
      img: false,
      imgSrc: '',
      timeout: null,
      off() {
        this.timeout = setTimeout(() => {
          this.img = false;
          this.imgSrc = '';
        }, 400);
      },
      on(imgSrc) {
        clearTimeout(this.timeout);
        this.img = true;
        this.imgSrc = imgSrc;
      }
    }
  })

  Alpine.data('plpSlider', (mediaCount, maxMedia) => {
    return {
      mediaCount: Math.min(mediaCount, maxMedia),
      updateMarker() {
        const childWidth = this.$refs.slider.children[0].offsetWidth;
        const currentIndex = Math.round(this.$refs.slider.scrollLeft / childWidth);
        this.$refs.marker.style.left = ((100 / this.mediaCount) * currentIndex) + '%';
        this.$refs.marker.style.width = (100 / this.mediaCount) + '%';
      },
    }
  })

  Alpine.data('videoSwap', () => ({
    video: {
      ['x-intersect.once']() {
        for (var source in this.$el.children) {
          var videoSource = this.$el.children[source];
          if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
            videoSource.src = videoSource.dataset.src;
          }
        }
        this.$el.load();
      }
    }
  }))

});

document.addEventListener("scroll", function(e) {
  if(window.scrollY >= 100) {
    document.body.classList.add('body-scrolled');
  } else {
    document.body.classList.remove('body-scrolled');
  }
}, {passive: true});

function toggleMobileBodyScroll(removeScroll) {
  if(removeScroll) {
    return document.body.classList.add('tw-overflow-hidden');
  }
  document.body.classList.remove('tw-overflow-hidden');
}

/*
 * Collection dots
 */
function dots(slideCount) {
  return {
    activeIndex: 0,
    slideCount: slideCount,
    render() {
      if(this.$refs.slider.scrollLeft > 0) {
        this.activeIndex = Math.round(this.$refs.slider.scrollLeft / this.$refs.slider.clientWidth);
      } else {
        this.activeIndex = 0;
      }
    }
  }
}

function sendEvent(name, props = {}) {
  if (typeof gtag === "function") {
    gtag('event', name, Object.assign({ 'send_to': 'G-TNVCJ3MTVK' }, props));
  }
}

// Footer signup
$(function() {
  $('#email_signup').submit(function() {
    $(this).addClass('tw-opacity-25');
    $.post($(this).data('ajax-submit'), $(this).serialize(), function() {
      $('#email_signup_success').removeClass('tw-hidden');
      $('#email_signup').addClass('tw-hidden');
    }, 'json').always(function() {
      $('#email_signup').removeClass('tw-opacity-25');
    });
    return false;
  });
});